export default __webpack_public_path__ + "static/media/vue-icon.c286d2da.svg";